import type { ReactNode } from 'react';

export const symbol_swap_driving_apps: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M641-778H342q-13 0-21.5-8.5T312-808q0-13 8.5-21.5T342-838h299l-38-38q-9-9-9-22t9-22q9-9 22-9t22 9l91 91q9 9 9 21t-9 21l-91 91q-9 9-22 9t-22-9q-9-9-9-22t9-22l38-38ZM180-190h600v-214H180v214Zm144-68q16-16 16-39t-16-39q-16-16-39-16t-39 16q-16 16-16 39t16 39q16 16 39 16t39-16Zm390 0q16-16 16-39t-16-39q-16-16-39-16t-39 16q-16 16-16 39t16 39q16 16 39 16t39-16ZM237-627l38 38q9 9 9 22t-9 22q-9 9-22 9t-22-9l-91-91q-9-9-9-21t9-21l91-91q9-9 22-9t22 9q9 9 9 22t-9 22l-38 38h463q20 0 35.5 11.5T757-646l80 233q2 5 2.5 9.5t.5 9.5v314q0 17-11.5 28.5T800-40q-17 0-28.5-11.5T760-80v-50H200v50q0 17-11.5 28.5T160-40q-17 0-28.5-11.5T120-80v-324q0-25 17.5-42.5T180-464h574l-54-163H237Zm-57 223v214-214Z"
		/>
	</svg>
);
